import { CloseCircleFilled } from "@ant-design/icons";
import clsx from "clsx";
import { DatePicker, Row } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { leftArrowIcon, rightArrowIcon } from "../../../assets/icons";
import { dateRanges } from "../../../config/enum";
import { UIsecondaryButton } from "../button";
import "./style.css";

export const UICalendar = (props: any) => {
  const {
    className,
    dropdownClassName,
    params,
    setParams,
    handleChange,
    hideArrows,
  } = props;
  const { RangePicker } = DatePicker;

  const [range, setRange] = useState<any>();
  const [isVisible, setVisible] = useState(false);
  const onPrevClick = () => {
    switch (range) {
      case dateRanges.TODAY:
        return setParams([params[0].subtract(1, "day"), params[1]]);

      case dateRanges.YESTERDAY:
        return setParams([params[0].subtract(1, "day"), params[1]]);

      case dateRanges.THISWEEK:
        return setParams([
          params[0].subtract(1, "week"),
          params[1].subtract(1, "week"),
        ]);

      case dateRanges.LASTWEEK:
        return setParams([
          params[0].subtract(1, "week"),
          params[1].subtract(1, "week"),
        ]);

      case dateRanges.THISMONTH:
        return setParams([
          params[0].subtract(1, "month"),
          params[1].subtract(1, "month"),
        ]);

      case dateRanges.LASTMONTH:
        return setParams([
          params[0].subtract(1, "month"),
          params[1].subtract(1, "month"),
        ]);

      case dateRanges.LASTSIXMONTH:
        return setParams([
          params[0].subtract(6, "month"),
          params[1].subtract(6, "month"),
        ]);

      default:
        return setParams([params[0].subtract(1, "day"), params[1]]);
    }
  };
  const onNextClick = () => {
    switch (range) {
      case dateRanges.TODAY:
        return setParams([params[0], params[1].add(1, "day")]);

      case dateRanges.YESTERDAY:
        return setParams([params[0], params[1].add(1, "day")]);

      case dateRanges.THISWEEK:
        return setParams([params[0].add(1, "week"), params[1].add(1, "week")]);

      case dateRanges.LASTWEEK:
        return setParams([params[0].add(1, "week"), params[1].add(1, "week")]);

      case dateRanges.THISMONTH:
        return setParams([
          params[0].add(1, "month"),
          params[1].add(1, "month"),
        ]);

      case dateRanges.LASTMONTH:
        return setParams([
          params[0].add(1, "month"),
          params[1].add(1, "month"),
        ]);

      case dateRanges.LASTSIXMONTH:
        return setParams([
          params[0].add(6, "month"),
          params[1].add(6, "month"),
        ]);

      default:
        return setParams([params[0], params[1].add(1, "day")]);
    }
  };

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const weeklyOpt = document.elementFromPoint(e.clientX, e.clientY);
      const x = weeklyOpt?.textContent;
      if (
        x === dateRanges.LASTWEEK ||
        x === dateRanges.THISWEEK ||
        x === dateRanges.TODAY ||
        x === dateRanges.YESTERDAY ||
        x === dateRanges.THISMONTH ||
        x === dateRanges.LASTMONTH ||
        x === dateRanges.LASTSIXMONTH
      ) {
        setRange(x);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, []);

  const handleRange: any = {
    [dateRanges.TODAY]: [moment(), moment()],
    [dateRanges.YESTERDAY]: [
      moment().subtract(1, "day"),
      moment().subtract(1, "day"),
    ],
    [dateRanges.THISWEEK]: [moment().startOf("week"), moment().endOf("week")],
    [dateRanges.LASTWEEK]: [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
    [dateRanges.THISMONTH]: [
      moment().startOf("month"),
      moment().endOf("month"),
    ],
    [dateRanges.LASTMONTH]: [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    [dateRanges.LASTSIXMONTH]: [
      moment().subtract(6, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  const handleCancel = () => {
    return setVisible(false);
  };

  const extraFooter = () => {
    return (
      <>
        <UIsecondaryButton
          className="calendarCancel"
          type="sm"
          onPress={handleCancel}
        >
          <span className="calendarTxtCncl">Cancel</span>
        </UIsecondaryButton>
      </>
    );
  };
  return (
    <div>
      <Row>
        {!hideArrows && (
          <div className="duration-filter" onClick={onPrevClick}>
            <img src={leftArrowIcon} className="navigationIcon" alt="" />
          </div>
        )}

        <RangePicker
          showTime
            className={clsx(
              "uiCalendar-range !w-full !h-10 !rounded-lg !border !border-slate-200 !px-3 !text-sm",
              className
            )}
          key={params?.toString()}
          format="MM/DD/YY"
          dropdownClassName={
            dropdownClassName
              ? `rangeDropDown ${dropdownClassName}`
              : "rangeDropDown"
          }
          renderExtraFooter={extraFooter}
          ranges={handleRange}
          defaultValue={params}
          allowClear={false}
          value={params}
          open={isVisible}
          onChange={(e: any, x) => handleChange(e, x)}
          separator={<span style={{ fontSize: "14px" }}>-</span>}
          onOk={() => {
            setRange(null);
          }}
          onCalendarChange={(obj: any) => {
            if (!!obj[0] && !!obj[1]) {
              setVisible(false);
            }
          }}
          onClick={() => setVisible(true)}
           
        />

        {params?.length ? (
          <div
            className="closeIconBtn"
            onClick={() => {
              handleChange([]);
              setParams([]);
              setVisible(false);
            }}
          >
            <CloseCircleFilled style={{ color: "rgba(0,0,0,.25)" }} />
          </div>
        ) : (
          ""
        )}

        {!hideArrows && (
          <div className="duration-filter" onClick={onNextClick}>
            <img src={rightArrowIcon} className="navigationIcon" alt="" />
          </div>
        )}
      </Row>
    </div>
  );
};
